import React, { useId } from "react";

interface CustomTextFieldProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  label?: string;
  error?: boolean;
  helperText?: string | false;
  variant?: string;
  size?: string | number;
  fullWidth?: boolean;
  InputLabelProps?: any;
  InputProps?: any;
  sx?: any;
  margin?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  label,
  error,
  helperText,
  className = "",
  variant,
  size,
  fullWidth,
  InputLabelProps,
  InputProps,
  sx,
  margin,
  ...props
}) => {
  const generatedId = useId();

  return (
    <div className="form-group mb-2">
      {label && <label htmlFor={generatedId}>{label}</label>}
      <input id={generatedId}
        className={`form-control ${error ? "is-invalid" : ""} ${className}`}
        {...props}
      />
      {error && helperText && (
        <div className="invalid-feedback">{helperText}</div>
      )}
    </div>
  );
};

export default CustomTextField;
